export default __webpack_public_path__ + "static/media/logo-sinfin-black.8e334680.svg";